import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { BrowserRouter } from 'react-router-dom'
import { Analytics } from '@vercel/analytics/react'
import { Provider } from 'react-redux'
import store from './redux/store'
import { HelmetDispatcher } from './HelmetDispatcher'

const rootElement = createRoot(document.getElementById('root'))
rootElement.render(
    <Provider store={store}>
        <HelmetDispatcher />
        <BrowserRouter>
            <App />
        </BrowserRouter>
        <Analytics />
    </Provider>
)
